import { transformItemsGroup } from "features/Products/helpers";

/** Обрезает длинные названия по середине: «Начало…конец» */
export const truncateMiddle = (str, max = 38) => {
  if (!str || str.length <= max) return str;
  const half = Math.floor((max - 1) / 2);
  return `${str.slice(0, half)}…${str.slice(str.length - half)}`;
};

/**
 * Плоский список опций для селектов групп:
 * дерево разворачивается в порядке обхода,
 * вложенность отражается символами «•».
 */
export const buildGroupOptions = (groups = [], { withRoot = true } = {}) => {
  const options = [];

  const walk = (nodes, depth) => {
    for (const node of nodes) {
      options.push({
        value: String(node.itemgroupid),
        label: `${"\u2022\u00a0".repeat(depth)}${truncateMiddle(node.name)}`,
        group: node,
      });
      if (node.children?.length) walk(node.children, depth + 1);
    }
  };

  walk(transformItemsGroup(groups), 0);

  return withRoot
    ? [{ value: "0", label: "Все товары", group: null }, ...options]
    : options;
};
